import React from "react";
import { useNavigate } from "react-router-dom";
import {
  Section,
  Container,
  Heading,
  Card,
  CardInner,
  Button,
} from "toddlar-ui";

const Welcome: React.FC = () => {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-sand-50">
      <Section background="sand">
        <Container>
          <Heading size="display" className="text-ink md:leading-[1.05]">
            Welcome to Toddlar
          </Heading>
          <Heading as="p" size="lead" className="mt-4">
            Here’s how subscriptions and ordering work
          </Heading>
          <div className="mt-8 flex gap-4">
            <Button onClick={() => navigate("/browse")} size="large">
              Start an Order
            </Button>
          </div>
        </Container>
      </Section>

      <Section>
        <Container>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
            {[
              {
                title: "Subscribe",
                desc: "Start your plan and get 800 points every month.",
              },
              {
                title: "Choose",
                desc: "Use points to pick toys you want to receive.",
              },
              {
                title: "Swap & repeat",
                desc: "Return toys and order again when you’re ready.",
              },
            ].map((step) => (
              <Card key={step.title}>
                <CardInner>
                  <h3 className="text-xl font-semibold text-ink">
                    {step.title}
                  </h3>
                  <p className="mt-2 text-ink-muted">{step.desc}</p>
                </CardInner>
              </Card>
            ))}
          </div>
        </Container>
      </Section>
    </div>
  );
};

export default Welcome;
